import {
  GetParentObject,
  Comparison,
  QuestionNamesById,
  QuestionThreadParent,
  TriggerValue,
} from '@src/app-components/dynamic-form/types';

export const nprQuestionNameById: QuestionNamesById = {
  1: 'npr_NavWotus',
  8: 'npr_DumpOcean',
  2: 'npr_DischargeWotus',
  3: 'npr_FloatingDock',
  4: 'npr_S404',
  5: 'npr_Fallback',
  6: 'npr_PileStructure',
  7: 'npr_PileEffectsFill',
  9: 'ex_ImpactNavWotus',
  10: 'ex_Toxic307',
  11: 'ex_ReachReduced',
  12: 'ex_DischargeFarming',
  13: 'ex_EstablishedFarming',
  14: 'ex_EmergMaintenance',
  15: 'ex_OriginalFillDesign',
  16: 'ex_ReconstructAfterDamage',
  17: 'ex_TempImpactMaintenance',
  18: 'ex_ConstructionPonds',
  24: 'ex_ConstructTempBasin',
  25: 'ex_DischargeFillRoads',
  26: 'ex_RoadDesign',
  27: 'ex_RestrictFloodFlow',
  28: 'ex_RestrictAquaticLife',
  29: 'ex_PublicWaterSupply',
  30: 'ex_ShellfishProduction',
  31: 'ex_NWSR',
  32: 'ex_ToxicFree',
  33: 'ex_TempFillRestored',
  34: 'ex_StateApproved',
  35: 'ex_ConstructionDitch', // 18b
};

export const nprQuestionIdByName = Object.fromEntries(
  Object.entries(nprQuestionNameById).map(([key, value]) => [value, parseInt(key)])
);

export const getParentObject: GetParentObject = (
  parentId: number,
  parentTypeId: number,
  comparison: Comparison,
  triggerValue: TriggerValue
): QuestionThreadParent => {
  const parentName = nprQuestionNameById[parentId as keyof typeof nprQuestionNameById] as string;

  return {
    parentId,
    parentName,
    comparison,
    triggerValue,
    parentTypeId,
  };
};
